define('app-Gdpr/main',["./settings", "../app-Loader/main", '../app/ui/dialog'], function (globalSettings, loader, dialog) {
    return {
        settings: {},
        radioControlIds: {
            no: 'grandparentno',
            choose: 'grandparentchoose',
            yes: 'grandparentyes'
        },
        sliderDuration: 200,
        existingConsents: [],
        trackingCall: "cruiseGDPRSubmitted",

        // takes "settings" object, valid settings are
        // settings.container = container to load gdpr within
        // settings.product = Determine the journey where consent is recorded. Valid values are "BookingJourney" or "FormCapture".
        // settings.person = person object (not required for booking engine journey)
        // settings.continueButton = only override if we are to use separate continue button, and not one provided by GDPR form
        // settings.continueCallback = method used upon continuing 
        // settings.continueImmediately = set to true if you wish to continue immediately upon gdpr form returning (default false)
        display: function (settings) {
            var self = this;

            settings.continueCallback = settings.continueCallback || function () { };
            settings.gdprFormLoadCallback = settings.gdprFormLoadCallback || function () { };
            settings.continueImmediately = !!settings.continueImmediately;
            settings.person = settings.person || null;
            self.settings = settings;
            self.settings.container.empty();
            self.settings.showSubmitLoader = settings.showSubmitLoader;
            loader.show("Retrieving your preferences...");

            var request = $.ajax({
                url: globalSettings.retrieveFormUrl,
                type: "POST",
                data: JSON.stringify({ "leadPerson": self.settings.person, "product": self.settings.product, "journey": self.settings.journey }),
                dataType: "html",
                contentType: "application/json"
            });

            request.done(function (result) {
                if (result && result.length > 0) {

                    //Free text content from CMS. Usually from "closing text" field
                    $('.hide-when-gdpr-displayed').slideUp(self.sliderDuration);

                    self.settings.container.append(result);

                    var gdprForm = $(globalSettings.gdprFormContent),
                        parentConsents = gdprForm.find(globalSettings.parentConsentCheckboxes),
                        preSelectedConsents = parentConsents.filter(":checked"),
                        acknowledgement = gdprForm.find(globalSettings.acknowledgement),
                        overlayLinks = $(globalSettings.overlayLinks),
                        wordingId = gdprForm.find("input[type='hidden'][name='wording-id']").val();

                    for (var i = 0; i < preSelectedConsents.length; i++) {
                        self.existingConsents.push($(preSelectedConsents[i]).val());
                    }

                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip({
                            "offset": -80,
                            "template": "<div class='tooltip gdpr-tooltip' role='tooltip'><div class='arrow'></div><div class='tooltip-inner'></div></div>"
                        })
                    });

                    gdprForm.find(globalSettings.grandParentRadioButtons).on("change", function (e) {
                        self.resetValidation();

                        var inputId = e.currentTarget.id.toLowerCase();
                        //Toggle parent consents
                        inputId === self.radioControlIds.choose
                            ? gdprForm.find(globalSettings.parentConsentsContainer).slideDown(self.sliderDuration, self.toggleAcknowledgement())
                            : gdprForm.find(globalSettings.parentConsentsContainer).slideUp(self.sliderDuration, function () {
                                if (inputId === self.radioControlIds.no || inputId === self.radioControlIds.yes) {
                                    acknowledgement.slideDown(self.sliderDuration);
                                }
                            });
                        self.updateGdprBusinessArea();
                        AdlAddUpdateItem("gdprConsent", $(e.currentTarget).data("adl-consent"));
                    });

                    parentConsents.on('change', function () {
                        self.updateGdprBusinessArea();
                        self.resetValidation();
                        self.toggleAcknowledgement();
                    });

                    overlayLinks.on('click', function (e) {
                        e.preventDefault();
                        var contentId = $(e.currentTarget).data('content-id'),
                            contentElement = gdprForm.find('#' + contentId),
                            header = contentElement.data('content-header'),
                            content = contentElement.html();

                        dialog.show(header, content, { noClose: false });
                    });

                    var gdprSubmit = function (e) {
                        e.preventDefault();

                        var validGdpr = self.validateGdpr();
                        if (!validGdpr)
                            return false;

                        if (settings.reportValidation) {
                            //Trigger client/browser validation
                            var validForm = document.querySelector('form').reportValidity();
                            if (!validForm)
                                return false;
                        }  

                        self.loadPermissions(self.settings.showSubmitLoader);
                        e.currentTarget.setAttribute('disabled', '');
                    }

                    if (self.settings.continueButton && self.settings.continueButton.length > 0) {
                        self.settings.continueButton.on("click", gdprSubmit);
                    } else {
                        var submitButton = gdprForm.find("input[type='submit']");
                        submitButton.on("click", gdprSubmit).removeClass("d-none");;
                    }

                    self.initialiseDataLayer("yes", self.existingConsents.length > 0 ? "yes" : "no", wordingId, "", "");
                    self.settings.gdprFormLoadCallback();
                } else {
                    self.initialiseDataLayer("no", "", "", "", "");
                    _satellite.track(self.trackingCall); 
                    if (self.settings.continueImmediately) {
                        self.settings.continueCallback();
                    }
                }
            });

            request.fail(function () {
                self.initialiseDataLayer("no", "", "", "", "");
                _satellite.track(self.trackingCall); 
                if (self.settings.continueImmediately) {
                    self.settings.continueCallback();
                }
            });

            request.always(loader.hide);
        },

        initialiseDataLayer: function (gdprShown, gdprPrefReturned, gdprWordingID, gdprBusinessArea, gdprConsent) {
            AdlAddUpdateItem("gdprShown", gdprShown);
            AdlAddUpdateItem("gdprPrefReturned", gdprPrefReturned);
            AdlAddUpdateItem("gdprWordingID", gdprWordingID);
            AdlAddUpdateItem("gdprBusinessArea", gdprBusinessArea);
            AdlAddUpdateItem("gdprConsent", gdprConsent);
        },

        updateGdprBusinessArea: function () {
            var self = this,
                grandParent = $(globalSettings.grandParentRadioButtons).filter(":checked");
            if (grandParent.attr("id").toLowerCase() === self.radioControlIds.choose) {
                var selectedParents = $(globalSettings.parentConsentsContainer).find("input[type='checkbox']:checked");
                AdlAddUpdateItem("gdprBusinessArea", selectedParents.length > 0 ? $.map(selectedParents, function (element) { return $(element).data("adl-consent"); }).join('|') : "");
            } else {
                AdlAddUpdateItem("gdprBusinessArea", "");
            }
        },

        toggleAcknowledgement: function () {
            var self = this,
                gdprForm = $(globalSettings.gdprFormContent),
                selectedParents = gdprForm.find(globalSettings.parentConsentCheckboxes).filter(":checked"),
                acknowledgement = gdprForm.find(globalSettings.acknowledgement);

            if (selectedParents.length === 0) {
                acknowledgement.slideUp(self.sliderDuration);
            } else {
                self.consentsMatch(selectedParents)
                    ? acknowledgement.slideUp(self.sliderDuration)
                    : acknowledgement.slideDown(self.sliderDuration);
            }
        },

        consentsMatch: function (selectedParents) {
            var self = this,
                selectedIds = [];

            for (var i = 0; i < selectedParents.length; i++) {
                selectedIds.push(selectedParents[i].value);
            }

            if (selectedIds.length !== self.existingConsents.length)
                return false;

            for (var i = 0; i < selectedIds.length; i++) {
                if (self.existingConsents.indexOf(selectedIds[i]) < 0) {
                    return false;
                }
            }
            return true;
        },

        validateGdpr: function () {
            var self = this,
                form = $(globalSettings.gdprFormContent),
                grandParentConsents = form.find(globalSettings.grandParentRadioButtons),
                selectedRadio = grandParentConsents.filter(':checked');

            if (!selectedRadio.length > 0) {
                grandParentConsents.find('+ label').addClass('invalid');
                $(globalSettings.grandParentValidationMessage).removeClass("d-none");
                return false;
            }

            var selectedId = selectedRadio[0].id.toLowerCase();
            if (selectedId === self.radioControlIds.no || selectedId === self.radioControlIds.yes) {
                return true;
            }

            var parentConsents = form.find(globalSettings.parentConsentCheckboxes);
            var selectedParentConsents = parentConsents.filter(':checked');
            if (selectedParentConsents.length > 0) {
                return true;
            }

            $(globalSettings.parentValidationMessage).removeClass('d-none');
            parentConsents.find('+ label').addClass('invalid');
            return false;
        },

        loadPermissions: function (showSubmitLoader) {
            if (showSubmitLoader)
                loader.show("Saving your preferences...");

            var self = this,
                gdprForm = $(globalSettings.gdprFormContent),
                grandParent = gdprForm.find(globalSettings.grandParentRadioButtons).filter(":checked"),
                wordingId = parseInt(gdprForm.find("input[type='hidden'][name='wording-id']").val()),
                pKey = parseInt(gdprForm.find("input[type='hidden'][name='pkey']").val()),
                grandparentChannelId = parseInt(gdprForm.find("input[type='hidden'][name='grandparent-channeltree-id']").val()),
                grandparentId = parseInt(gdprForm.find("input[type='hidden'][name='grandparent-product-id']").val()),
                grandparentConsentStatusId = parseInt(grandParent.val()),
                journey = $('#gdprJourney').val();

            var requestObject = {
                wordingID: wordingId,
                journey: journey,
                capturedConsents: [
                    {
                        productTreeID: grandparentId,
                        consentStatusID: grandparentConsentStatusId,
                        channelTreeID: grandparentChannelId
                    }
                ]
            };

            if (grandParent.attr("id").toLowerCase() === "grandparentchoose") {
                var consents = gdprForm.find(globalSettings.parentConsentCheckboxes);
                consents.each(function (i, e) {
                    requestObject.capturedConsents.push({
                        productTreeID: parseInt($(e).val()),
                        consentStatusID: $(e).is(":checked") ? 1 : 2,
                        channelTreeID: parseInt($(e).data("channeltree-id"))
                    });
                });
            }

            var request = $.ajax({
                url: globalSettings.AddUpdatePermissionUrl,
                type: "POST",
                data: JSON.stringify({ "pKey": pKey, "request": requestObject }),
                dataType: "html",
                contentType: "application/json"
            });

            request.done(function () {
                _satellite.track(self.trackingCall); 
            });

            request.always(function () {
                if (showSubmitLoader)
                    loader.hide();
                self.settings.continueCallback();
            });
        },

        resetValidation: function () {
            var form = $(globalSettings.gdprFormContent);
            form.find('.validation').addClass('d-none');
            form.find('input + label').removeClass('invalid');
        },

        run: function () {
            window.loadedModules("app-Gdpr");
        }
    }
});
